
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import { Spinner } from 'reactstrap';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { setError, fetchDepartments, addDepartment, updateDepartment, departmentsSelector } from 'slices/departmentsSlice';
import { fetchFacilities } from 'slices/facilitiesSlice';

const AddDepartmentForm = ({ item, handleClose, callback, show, statusPerm }) => {
    const dispatch = useDispatch()
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
    const { error, loader } = useSelector(departmentsSelector);
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        setValue('facility_id', item?.facility_id || '')
        setValue('department_name', item?.department_name || item?.name || '')
        setValue('address', item?.address || '');
        setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
        dispatch(setError({}))
    }, [item])

    const ResetField = () => {
        setValue('facility_id', '')
        setValue('department_name', '')
        setValue('address', '')
        setValue('status', 1)
        setfilterFacilities(null)
    }

    useEffect(() => {
        !show && ResetField();
        return () => ResetField()
    }, [show])

    const [filterFacilities, setfilterFacilities] = useState(null)

    useEffect(() => {
        if (item?.facility?.abbreviation || item?.facility?.name) {
            setfilterFacilities({
                label: item?.facility?.abbreviation || item?.facility?.name || "",
                value: item?.facility?.id || ""
            })
        } else {
            setfilterFacilities(null)
        }
    }, [item?.facility])

    const filteredFacitiesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchFacilities(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: val.abbreviation || val.name,
            })),
            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };

    const submitCallback = (status, message) => {
        if (status) {
            callback()
            toast.success(message, {
                className: "successToast",
            })
            handleClose()
            ResetField()
            setButtonLoader(false)
            dispatch(fetchDepartments(1))
        }
        else {
            toast.error(message, {
                className: "errorToast",
            });
            setButtonLoader(false)
        }
    };

    const onSubmit = (data) => {
        setButtonLoader(true);
        const payload = {
            facility_id: data.facility_id,
            department_name: data.department_name,
            address: data.address,
            status: data.status
        }
        if (item?.id) {
            dispatch(updateDepartment(payload, item?.id, submitCallback, false));
        }
        else
            dispatch(addDepartment(payload, submitCallback, false));
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row-primary">
                <h2>Facility *</h2>
                <div className='w-100'>
                    <Controller
                        name="facility_id"
                        control={control}
                        rules={{
                            required: "Please select a facility"
                        }}
                        render={({ field }) =>
                            <div style={{ width: "100%" }}>
                                <AsyncPaginate
                                    menuPlacement='auto'
                                    styles={{
                                        ...selectCustomStyles,
                                    }}
                                    value={filterFacilities}
                                    loadOptions={filteredFacitiesLoadOptions}
                                    isClearable
                                    escapeClearsValue
                                    onChange={(obj) => {
                                        setfilterFacilities(obj)
                                        field.onChange(obj?.value || null);
                                    }}
                                    additional={{
                                        page: 1,
                                    }}
                                />
                                {errors?.facility_id?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.facility_id?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row-primary">
                <h2>Department Name *</h2>
                <div className="w-100">
                    <Controller
                        name="department_name"
                        control={control}
                        rules={{
                            required: "Department name is required"
                        }}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='department_name' placeholder='Department name' {...field} />
                                {errors?.department_name?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.department_name?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row-primary">
                <h2>Address</h2>
                <div className="w-100">
                    <Controller
                        name="address"
                        control={control}
                        render={({ field }) =>
                            <div className="w-100">
                                <input className="input-in type_inp" type="text" name='address' placeholder='Address' {...field} />
                            </div>
                        }
                    />
                </div>
            </div>


            {statusPerm &&
                <div className="row-primary" style={{ alignItems: "center" }}>
                    <h2>Status</h2>
                    <Controller name="status" control={control} required
                        rules={{
                            required: true
                        }}
                        render={({ field }) => (
                            <CustomSwitch labelText={field.value == 1 ? "Active" : "Inactive"} checked={field.value} handleChange={(checked) => field.onChange(checked ? 1 : 0)} />
                        )}
                    />
                </div>
            }

            <div className="Form-footer">
                <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
                <button type="submit" disabled={buttonLoader ? 'disabled' : ''} className="main_button">
                    {buttonLoader ?
                        <>
                            <Spinner size="sm">
                                Loading...
                            </Spinner>
                            <span> Loading</span>
                        </>
                        :
                        <span>
                            {item?.id ? "Update" : "Create"}
                        </span>
                    }
                </button>
            </div>
        </form>
    )
}

const AddDepartment = ({ item, onClose, callback, show, statusPerm }) => {
    return (
        <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content full_modal">
                    <div className="modal-header header_modal align-items-center">
                        <div></div>
                        <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Department</h5>
                        <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body modal_form_body">
                        <AddDepartmentForm item={item} handleClose={onClose} show={show} callback={callback} statusPerm={statusPerm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddDepartment
